export interface BulletinSchoolVM {
    bulletinSchoolId?: number;
    bulletinId?: number;
    schoolName: string;
    schoolNumber: string;
    checked: boolean;
}

export interface BulletinCityVM {
    city: string;
    checked: boolean;
}

export interface BulletinGradeLevelVM {
    gradeLevel: string;
    checked: boolean;
}

export interface BulletinSchool {
    bulletinSchoolId: number;
    bulletinId: number;
    schoolNumber: string;
    bulletin?: Bulletin; // TODO: Not sure if this is needed
}

export interface Bulletin {
    bulletinId: number;
    message: string;
    type: string;
    startDate?: string | Date;
    endDate?: string | Date;
    dateCreated: string | Date;
    dateUpdated?: string | Date;
    updatedBySapid: string;
    active: boolean;
    title: string;
    link: string;
    bulletinSchool: BulletinSchool[];
}

export interface BulletinVM {
    bulletinId: number;
    message: string;
    type: string;
    startDate?: string | Date;
    endDate?: string | Date;
    // startTime: string;
    // endTime: string;
    dateCreated: string | Date;
    dateUpdated?: string | Date;
    updatedBySapid: string;
    active: boolean;
    title: string;
    link: string;
    bulletinSchool: BulletinSchool[];
    schools: BulletinSchoolVM[];
    cities: BulletinCityVM[];
    gradeLevels: BulletinGradeLevelVM[];
    allSchools: boolean;
    byGradeLevel: boolean;
    byCity: boolean;
    bySchool: boolean;
    bulletinSchoolCount: string;
    bulletinLive: boolean;
}

export const GradeLevels: BulletinGradeLevelVM[] = [
    { gradeLevel: 'PreK', checked: false },
    { gradeLevel: 'Elementary', checked: false },
    { gradeLevel: 'Middle', checked: false },
    { gradeLevel: 'High', checked: false },
    { gradeLevel: 'Tech', checked: false },
    { gradeLevel: 'Adult', checked: false },
    { gradeLevel: 'ESE', checked: false },
    { gradeLevel: 'Charter', checked: false },
    { gradeLevel: 'Choice', checked: false },
    { gradeLevel: 'Magnet', checked: false },
    { gradeLevel: 'IB', checked: false },
];

export const GradeLevelsFromDB: BulletinGradeLevelVM[] = [
    { gradeLevel: 'PreK', checked: true },
    { gradeLevel: 'Elementary', checked: true },
    { gradeLevel: 'Middle', checked: true },
    { gradeLevel: 'High', checked: false },
    { gradeLevel: 'Tech', checked: false },
    { gradeLevel: 'Adult', checked: false },
    { gradeLevel: 'ESE', checked: false },
    { gradeLevel: 'Charter', checked: false },
    { gradeLevel: 'Choice', checked: false },
    { gradeLevel: 'Magnet', checked: false },
    { gradeLevel: 'IB', checked: false },
];